import React, { useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import { useAuth } from '@workos-inc/authkit-react';
import { ThemeProvider } from './contexts/ThemeContext';
import './App.css';
import Profile from './components/Profile';
import Callback from './components/Callback';
import LandingPage from './components/LandingPage';
import ProtectedRoute from './components/ProtectedRoute';
import Home from './components/Home';
import MainLayout from './components/MainLayout';
import ToolRouteHandler from './components/ToolRouteHandler';
import ToolView from './components/ToolView';
import { setDynamicTitle } from './scripts/branding';

function AppContent() {
  const { signIn } = useAuth();

  useEffect(() => {
    setDynamicTitle();
  }, []);

  return (
    <div className="main-content">
      <Routes>
        <Route path="/" element={<LandingPage onLoginClick={() => signIn()} />} />
        <Route path="/callback" element={<Callback />} />
        <Route element={<ProtectedRoute />}>
          <Route element={<MainLayout />}>
            <Route path="/profile" element={<Profile />} />
            <Route path="/home" element={<Home />} />
            <Route path="/tools/:toolPath" element={<ToolRouteHandler />} />
            <Route path="/:toolPath" element={<ToolView />} />
          </Route>
        </Route>
      </Routes>
    </div>
  );
}

function App() {
  return (
    <ThemeProvider>
      <AppContent />
    </ThemeProvider>
  );
}

export default App;